import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from 'react-awesome-modal';
import { List } from 'react-virtualized';
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {css} from "@emotion/core";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilterSingleSelect.jsx';
import "./refund_module.css";
import OriginalTxnId from '../../filters/OriginalTxn.jsx';
import RefundBankRRN from '../../filters/RefundBankRRN.jsx';
import OriginalBankRRN from '../../filters/OriginalBankRRN.jsx';
import CustomerVPA from '../../filters/CustomerVPA.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2024-02-01','1');
var RefundSummaryTable='';

class RefundSummary extends Component{
    constructor(props) {
        super(props);
        this.state ={
            _notificationSystem: null,
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            tableLoading: true,
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            isChange: false,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            industryCategoryList:[],
            industryCategoryValue: null,
            industryCategoryIds:'',
            fetch_data:false,
            chartHeight: "280px",
            search_type:'Store',
            original_txn_id:"",
            refund_bank_rrn:"",
            original_bank_rrn:"",
            customer_vpa:"",
            date_type:"current_date",
            afterrefund:10000,
            autorefresh:30000
        }
    }
    onDateTypeChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value,
            search_type:"Store",
            original_txn_id:"",
            refund_bank_rrn:"",
            original_bank_rrn:"",
            customer_vpa:"",
            txnTypeIDs:""
        });

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentWillMount() {
        axios.post(config.get('API_URL')+'/RefundModule/refund_days_limit/',{

        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
        //alert(response.data[0].refund_days_limit)
        var date_limit = new Date(Date.now() - response.data[0].refund_days_limit*24*60*60*1000);
        var start_date_limit = moment(date_limit).format('MM/DD/YYYY');
        this.setState({
            refund_days_limit:start_date_limit
        })

        });
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        //isReportAccess(AllAccessPermissions, 'daily_settlement');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
            user_email: decoded.email
        });
    }

    componentDidUpdate() {
    }
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    var data = {};
    //this.handleRefund(data);
        this.get_refresh_time();
        this.get_filtered_refund_summary(this.state.object_type,this.state.object_code,'manual','');

        //user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'daily_settlement_report','sparcs')
     }
     get_refresh_time(){
        axios.get(config.get('API_URL')+'/RefundModule/get-refresh-time/',
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {

            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                afterrefund:response.data.afterrefund,
                autorefresh:response.data.autorefresh
            })
            this.intervalId = setInterval(() => {
                this.reloadDataTable();
            }, response.data.autorefresh);

        }).catch(error => {
          console.log(error);
        });
    }
    reloadDataTable() {
       $('#RefundSummaryTable').DataTable().settings()[0].oFeatures.bProcessing = false;
        this.setState({ showProcessing: false }, () => {
            $('#RefundSummaryTable').DataTable().ajax.reload(null, false);
        });
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    downLoadRefundSummary(e){
        let transaction_type = this.state.transaction_type;
        if (Array.isArray(this.state.transaction_type) && this.state.transaction_type.includes("all") === true) {
            transaction_type = []
        }
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(this.state.object_type === 'Merchant' && this.state.merchantID===''){
            merchants = this.state.object_code;
        }
        if(this.state.object_type==='Chain' && this.state.chainID===''){
            chains = this.state.object_code;
        }
        if(this.state.object_type==='Store' && this.state.storeID===''){
            stores = this.state.object_code;
        }
        var yestSend1= this.state.yestSend;
        var todSend1= this.state.todSend;
        if(this.state.date_type==='current_date') {
            var date_config1 = date_range_config('0', '0', '2020-02-01','0');
            yestSend1 = date_config1.start_date_value;
            todSend1 = date_config1.end_date_value;

        }
        let filters = {
            merchant_codes: merchants,
            chain_codes: chains,
            store_codes: stores,
            upi_txn_id: this.state.original_txn_id,
            bo_rrn_number: this.state.refund_bank_rrn,
            bo_refund_rrn_number:this.state.refund_bank_rrn,
            customer_vpa: this.state.customer_vpa,
            start_date: yestSend1,
            end_date: todSend1,
            download: 1
        }
        this.setState({
            filters:filters
        })
//         if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID===''&& this.state.acqBankIds==='' && this.state.cityIds===''){
//             confirmAlert({
//             //title: 'Warning',
//                 message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
//                 buttons: [{
//                     label: 'OK',
//                     onClick: () => {
//                         this.refs.downloadAllReport.downLoadReport(filters, '/hdfc_refund/upi/transaction/refund','refund_summary');
//                     }
//                 },
//                     {
//                         label: 'Cancel',
//                     }
//                 ]
//             });
//         } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/hdfc_refund/upi/transaction/refund','refund_summary');
        //}
    }

    get_filtered_refund_summary(object_type, object_code, refresh_type, event) {
        var that= this;
        if ($.fn.DataTable.isDataTable('#RefundSummaryTable')) {
            $('#RefundSummaryTable').DataTable().clear().destroy();
        }

        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids:merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: this.state.acqBankIds,
            active_cityids: this.state.cityIds,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
        })
        var yestSend1= this.state.yestSend;
        var todSend1= this.state.todSend;
        if(this.state.date_type==='current_date') {
            var date_config1 = date_range_config('0', '0', '2020-02-01','0');
            yestSend1 = date_config1.start_date_value;
            todSend1 = date_config1.end_date_value;

        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            upi_txn_id: this.state.original_txn_id,
            bo_rrn_number: this.state.original_bank_rrn,
            customer_vpa: this.state.customer_vpa,
            bo_refund_rrn_number: this.state.refund_bank_rrn,
            yestSend: yestSend1,
            todSend: todSend1
        };
        var RefundSummaryTable = $('#RefundSummaryTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                // "language": {
                //     processing: '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading..n.</span> '},
                //
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                //"sPaginationType": "numbers",
                //"scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/RefundModule/refund_summary/",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {

                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {

                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data":"Merchant Name"},
                    {"data":"Chain Name"},
                    {"data":"Store Name"},
                    {"data":"Store Address"},
                    {"data":"City"},
                    {"data":"State"},
                    {"data":"original_txn_id"},
                    {"data":"refund txn id"},
                    {"data":"original RRN"},
                    {"data":"Refund RRN"},
                    {"data":"customer_vpa"},
                    {"data":"Bank Name"},
                    {"data":"Date and Time"},
                    {"data":"Refund amount"},
                    {"data":"status"},
                    {"data":"Message"},
                    {"data":"sub merchant ID"}

                ],
                "columnDefs": [
//                     {
//                         width: "150px",
//                         targets: 0,
//                     },
//                     {
//                         width: "130px",
//                         targets: 1,
//                     },

                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';
                        },
                        "width": "90px",
                        "targets": 12
                    },
//                     {
//                         render: function (data, type, full, meta) {
//                             if(data===null || data===''|| data ==='null'){
//                             data = '';
//                             }
//                             return "<div class='text-wrap width-150'>" + data + "</div>";
//                         },
//                         "targets": [0,1,4]
//                     },
//                     {
//                         "targets": 11,
//                         "orderable": false
//                     },
                       {
                        "width": "90px",
                        "targets": 16,
                        "data": "data",
                        "className": "text-center",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');
                            if(rowData.status==='Success' || rowData.status==='Pending' || rowData.status==='Refund-initiated' || rowData.status==='Refund failed' || rowData.status==='Unknown')  {
                                $(td).append(' <a href="#"  data-tip="Refund" title="Refund" id="Refund"  class="refundButton" >Refund</a>');
                                $(td).click(e => {
                                    this.handleRefund(e, rowData);
                                })
                            }


                        },
                        bSortable: false,
                    },

                ]
            });

    }
    handleRefund(e, data) { //console.log(data);
        confirmAlert({
            //title: 'Warning',
                message: "Are you sure you want to refund?",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.handleRefund1(e,data);
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
       //e.preventDefault();
    }
    handleRefund1(e,data){
    var transaction_date= data['Date and Time'];
    transaction_date = moment(transaction_date).format('YYYY-MM-DD');
        data.refunded_by = this.state.user_email;
        data.transaction_date = transaction_date;
        console.log(data);

        axios.post(config.get('API_URL')+'/RefundModule/push_message/',data,
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            console.log(response)
             if(response.data.status==="success") {
                 const row = $(e.target).closest('tr'); // Find the closest row
                 const statusCell = row.find('td').eq(7); // Assuming "status" is the 8th column (index 7)
                 statusCell.text('Refund-initiated');
                // Optionally, add some styling to indicate change
               // statusCell.css('color', 'green'); // Change text color to green
               this.handleNotificationClick("tr", 1, "Your refund request has been initiated. Please allow some time for the transaction to complete. Thank you for your patience during the processing period.");
               //this.interval = setInterval(() => this.get_filtered_refund_summary(this.state.object_type,this.state.object_code,''), 30000);
               this.insert_into_history(data)
               this.timeout = setTimeout(() => {
                  this.reloadDataTable();
               }, this.state.afterrefund);
             }
             else {
                this.handleNotificationClick("tr", 1,response.data.message);
             }
        });
    }

    insert_into_history(data){
        data.object_code = this.state.object_code;
        data.object_type = this.state.object_type;
        axios.post(config.get('API_URL')+'/RefundModule/insert_into_history/',data,
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            console.log(response)

        });
    }
    reset_all(e){
         this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
//             this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
//             this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');

        }

        this.refs.originalTxnFilter.resetOriginalTxnFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            campaignCodeValue:[],
            campaignCodeIDs:'',
            industryCategoryIds:'',
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }

    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        if(this.state.search_type==='Original txn id') {
            this.refs.originalTxnFilter.getOriginalTxn(this.state.object_type,this.state.object_code,false,'',yestSend, todSend);
        }
        if(this.state.search_type==='Refund Bank RRN') {
            this.refs.refundBankRRNFilter.getRefundBankRRN(this.state.object_type,this.state.object_code,false,'',yestSend, todSend);
        }
        if(this.state.search_type==='Original Bank RRN') {
            this.refs.bankRRNFilter.getOriginalBankRRN(this.state.object_type,this.state.object_code,false,'',yestSend, todSend);
        }
        if(this.state.search_type==='Customer VPA') {
            this.refs.customerVPAFilter.getCustomerVPA(this.state.object_type,this.state.object_code,false,'',yestSend, todSend);
        }


    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
//         this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
//             storeID:'',
//             ciutidIds: '',
        });
        //this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
//         this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
//         this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }

    handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    onSearchTypeChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        });
        if(value==='Customer VPA'){
            this.setState({
            storeID:"",
            original_txn_id:"",
            refund_bank_rrn:"",
            original_bank_rrn:"",
//             customer_vpa:""
            })
        }
        if(value==='Original Bank RRN'){
            this.setState({
            storeID:"",
            original_txn_id:"",
            refund_bank_rrn:"",
//             original_bank_rrn:"",
            customer_vpa:""
            })
        }
        if(value==='Refund Bank RRN'){
            this.setState({
            storeID:"",
            original_txn_id:"",
//             refund_bank_rrn:"",
            original_bank_rrn:"",
            customer_vpa:""
            })
        }
        if(value==='Original txn id'){
            this.setState({
            storeID:"",
//             original_txn_id:"",
            refund_bank_rrn:"",
            original_bank_rrn:"",
            customer_vpa:""
            })
        }
        if(value==='Store ID'){
            this.setState({
//             storeID:"",
            original_txn_id:"",
            refund_bank_rrn:"",
            original_bank_rrn:"",
            customer_vpa:""
            })
        }
    };
    handleOriginalTxn = (Data) =>{
        this.setState({
            isChange: true,
            original_txn_id:Data,
        })
    }
    handleRefundBankRRN = (Data) =>{
        this.setState({
            isChange: true,
            refund_bank_rrn:Data,
        })
    }
    handleOriginalBankRRN = (Data) =>{
        this.setState({
            isChange: true,
            original_bank_rrn:Data,
        })
    }
    handleCustomerVPA= (Data) =>{
        this.setState({
            isChange: true,
            customer_vpa:Data,
        })
    }
     render() {
        var yestSend2= this.state.yestSend;
        var todSend2= this.state.todSend;
        if(this.state.date_type==='current_date') {
            var date_config1 = date_range_config('0', '0', '2020-02-01','0');
            yestSend2 = date_config1.start_date_value;
            todSend2 = date_config1.end_date_value;
        }
        console.log("y",yestSend2)
        console.log("t",todSend2)
        return(
           
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Refund Summary</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                   <div>
                                   Search by:
                                    {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                    <React.Fragment>
                                   &nbsp;&nbsp;<input type="radio" name="search_type"
                                                                   value="Chain"
                                                                   checked={this.state.search_type === 'Chain'}
                                                                   onChange={this.onSearchTypeChanged} /> Chain Name</React.Fragment>: null }
                                    &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="search_type"
                                                                   value="Store"
                                                                   checked={this.state.search_type === 'Store'}
                                                                   onChange={this.onSearchTypeChanged} /> Store Name
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="search_type"
                                                                   value="Original txn id"
                                                                   checked={this.state.search_type === 'Original txn id'}
                                                                   onChange={this.onSearchTypeChanged} /> Original txn id / Upi txn id
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="search_type"
                                                                   value="Refund Bank RRN"
                                                                   checked={this.state.search_type === 'Refund Bank RRN'}
                                                                   onChange={this.onSearchTypeChanged} /> Refund Bank RRN
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;
                                                                   <input type="radio" name="search_type"
                                                                   value="Original Bank RRN"
                                                                   checked={this.state.search_type === 'Original Bank RRN'}
                                                                   onChange={this.onSearchTypeChanged} /> Original Bank RRN
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;
                                                                   <input type="radio" name="search_type"
                                                                   value="Customer VPA"
                                                                   checked={this.state.search_type === 'Customer VPA'}
                                                                   onChange={this.onSearchTypeChanged} />  Customer VPA
                                   </div>
                                   <div>

{/*                                         {this.state.object_type ==='Innoviti'? */}
{/*                                             <div className="col-md-2 filter-bottom5 padd-5"> */}
{/*                                                 <label>Merchants</label> */}
{/*                                                 <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/> */}
{/*                                                 <div className="clearfix"></div> */}
{/*                                             </div> : null} */}
                                            {this.state.search_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            { this.state.search_type ==='Store'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                                { this.state.search_type ==='Original txn id'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Original transaction ID/UPI ID </label>
                                                    <OriginalTxnId ref="originalTxnFilter" onSelectOriginalTxn = {this.handleOriginalTxn} start_date = {yestSend2} end_date={todSend2} />
                                                    <div className="clearfix"></div>
                                                </div>:null}
                                                { this.state.search_type ==='Refund Bank RRN'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Refund Bank RRN </label>
                                                    <RefundBankRRN ref="refundBankRRNFilter" onSelectRefundBankRRN = {this.handleRefundBankRRN} start_date = {yestSend2} end_date={todSend2} />
                                                    <div className="clearfix"></div>
                                                </div>:null}
                                                { this.state.search_type ==='Original Bank RRN'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Original Bank RRN </label>
                                                    <OriginalBankRRN ref="bankRRNFilter" onSelectOriginalBankRRN = {this.handleOriginalBankRRN} start_date = {yestSend2} end_date={todSend2} />
                                                    <div className="clearfix"></div>
                                                </div>:null}
                                                { this.state.search_type ==='Customer VPA'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Customer VPA </label>
                                                    <CustomerVPA ref="customerVPAFilter" onSelectCustomerVPA = {this.handleCustomerVPA} start_date = {yestSend2} end_date={todSend2} />
                                                    <div className="clearfix"></div>
                                                </div>:null}

{/*                                                 <div className="col-md-3 filter-bottom5 padd-5 date-icon-small"> */}
{/*                                                 <div><label> Date Filter: </label></div> */}
{/*                                                 <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow} */}
{/*                                                         start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/> */}
{/*                                                 </div> */}
                                                <div className="col-md-4 filter-bottom51 padd-5 date-icon-small" >
                                                    <input type="radio" name="date_type"
                                                                       value="current_date"
                                                                       checked={this.state.date_type === 'current_date'}
                                                                       onChange={this.onDateTypeChanged} /> Current Date
                                                                       &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="date_type"
                                                                       value="prev_date"
                                                                       checked={this.state.date_type === 'prev_date'}
                                                                       onChange={this.onDateTypeChanged} /> Previous Date

                                                </div>

                                                {this.state.date_type==='prev_date'?
                                                <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                        start_date_limit = {this.state.refund_days_limit} end_date_limit = {this.state.dateLimit}/>
                                                </div>:null}

                                    <div className="col-md-4">
{/*                                         {this.state.isChange===true? */}
{/*                                             <span className="apply-notification">Please click on Apply button</span>:null */}
{/*                                         } */}
                                        <button type="button" className="primary apply-filter1" role="button"  onClick={this.get_filtered_refund_summary.bind(this, this.state.object_type,this.state.object_code,'manual')}>Apply</button>
                                        <button type="button" className="primary apply-filter1" role="button"  onClick={this.get_filtered_refund_summary.bind(this, this.state.object_type,this.state.object_code,'manual')}>Refresh<i class="fa fa-refresh"  aria-hidden="true"></i></button>
                                    </div>


                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadRefundSummary.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                             Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="RefundSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Merchant Name</th>
                                                    <th>Chain Name</th>
                                                    <th>Store Name</th>
                                                    <th>Store Address</th>
                                                    <th>City</th>
                                                    <th>State</th>
                                                    <th>Original transaction ID</th>
                                                    <th>Refund transaction ID</th>
                                                    <th>Original Bank RRN</th>
                                                    <th>Refund RRN</th>
                                                    <th>Customer VPA</th>
                                                    <th>Bank Name</th>
                                                    <th>Date & Time</th>
                                                    <th>Refund Amount (INR)</th>
                                                    <th>Status</th>
                                                    <th>Message</th>
                                                    <th align="center">Refund</th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />



                                    <div className="clearfix"></div>


                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                                              
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(RefundSummary)